import * as Sentry from '@sentry/react';

export const sentryPspError = (errorMessage, pspGateway, paymentType) => {
  const error = new Error(`${pspGateway} payment failed`);
  error.name = `${pspGateway.toUpperCase()} PAYMENT DECLINED`;
  Sentry.captureException(error, {
    tags: {
      gateway: pspGateway,
      paymentType: paymentType,
      errorMessage: errorMessage,
    },
  });
};

export const sentryGlobalError = (errorMessage, errorBody, errorType) => {
  const error = new Error(`${errorType} error`);
  Sentry.captureException(error, {
    tags: {
      errorMessage: errorMessage,
      body: errorBody,
    },
  });
};
